import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { authActions } from "../../redux/store";
import { useBlogContext } from "../../fetchdata/BlogContext";
import getDecryptData from "../../helper/getDecryptData";
import eraseCookie from "../../helper/eraseCookie";
import getCookie from "../../helper/getCookie";
import { Host } from "../../axiosInstance";

const MenuItem = ({ item }) => {
  return (

    item.children && item.children.length > 0 ? null : (
      <li key={item.id} className={item.children ? "has_submenu " : ""}>
        <Link
          to={item.link.replace('{{id}}', (localStorage.getItem('location') !== "[object Object]" && localStorage.getItem('location')) ? localStorage.getItem('location') : "delhi")}
          target={item.target === "_blank" ? "_blank" : ""}>
          <div dangerouslySetInnerHTML={{ __html: item.text }} className="p-2 rounded-md" />
        </Link>
      </li>
    )

  );
};

const SubMenu = ({ items }) => {
  return (
    <ul className="submenu">
      <li>
        <span className="mobile_menu_back">
          <i className="ti ti-chevron-left"></i> Back
        </span>
      </li>
      {items.map((child) => (
        <MenuItem key={child.id} item={child} />
      ))}
    </ul>
  );
};

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userdata = getDecryptData();

  const {
    Headers,
    IsUserData,
  } = useBlogContext();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const isLogin = getCookie("token") ? true : false;

  const openSidebar = () => setIsSidebarOpen(true);
  const closeSidebar = () => setIsSidebarOpen(false);

  const handleLogout = () => {
    dispatch(authActions.logout());
    eraseCookie("token");
    eraseCookie("user");
    eraseCookie("userId");
    localStorage.clear();
    toast.success("Logout Successfully");
    navigate("/login");
  };

  return (
    <>
      {/* HEADER */}
      <header className="header px-3 pb-0">
        <div className="header-content d-flex justify-content-between align-items-center px-0">
          <button
            className="border-0 bg-transparent"
            onClick={openSidebar}
          >
            <i
              className=
              "fi fi-br-bars-sort fs-3 text-gold"
            ></i>
          </button>

          <Link to="/" className="fw-bold text-uppercase text-decoration-none logo-text">
            {Headers?.meta_title ? Headers.meta_title : "GOPAL JEWELS"}
          </Link>

          <NavLink to="/account/notification">
            <i className="ri-notification-3-line fs-4"></i>
          </NavLink>
        </div>
      </header>

      {/* OVERLAY */}
      <div
        className={`dark-overlay ${isSidebarOpen ? "active" : ""}`}
        onClick={closeSidebar}
      />

      {/* SIDEBAR */}
      <div className={`sidebar ${isSidebarOpen ? "show" : ""}`}>
        <NavLink to="/account" className="author-box" onClick={closeSidebar}>
          <div className="dz-media">
            <img
              src={
                IsUserData?.profile
                  ? Host + "uploads/users/" + IsUserData.profile
                  : "/assets/img/profile.webp"
              }
              alt="user"
            />
          </div>
          <div className="dz-info">
            <h5 className="name">{userdata?.username || "Guest User"}</h5>
            <span className="mail">{userdata?.email || "example@gmail.com"}</span>
          </div>
        </NavLink>

        <ul className="nav navbar-nav">
          {Headers.navbar &&
            Headers.navbar.length > 0 &&
            Headers.navbar.map((item) => (
              <MenuItem key={item.id} item={item} />
            ))}

          <li>
            {isLogin ? (

              <a type="button" onClick={handleLogout}>
                <div className="p-2">
                  <i className="ri-logout-box-r-line" /> Logout
                </div>
              </a>

            ) : (


              <NavLink to="/login" onClick={closeSidebar}>
                <i className="ri-group-fill" />
                <span>Login</span>
              </NavLink>
            )}
          </li>
        </ul>

        <div className="sidebar-bottom px-4">
          <h6><b>{Headers?.meta_title || "App Name"}</b></h6>
          <span>Version 1.0</span>
        </div>
      </div>
    </>
  );
};

export default Header;
